import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useBreadcrumbs } from "@/contexts/BreadcrumbContext";

export function Breadcrumb() {
  const stack = useBreadcrumbs();
  const navigate = useNavigate();

  // Hide when at a root page (single entry) or no history
  if (stack.length <= 1) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className="ds-caption flex min-w-0 shrink-0 items-center gap-1 overflow-x-auto bg-surface-container-low px-4 py-2 hidden-scrollbar sm:px-5"
    >
      {stack.map((entry, idx) => {
        const isLast = idx === stack.length - 1;
        const label = entry.label || "…";

        return (
          <React.Fragment key={`${entry.pathname}-${idx}`}>
            {idx > 0 && <ChevronRight className="w-3 h-3 text-muted-foreground/40 shrink-0" />}
            {isLast ? (
              <span className="text-foreground truncate max-w-[140px] sm:max-w-[220px]">
                {label}
              </span>
            ) : (
              <button
                onClick={() => navigate(entry.pathname + entry.search)}
                className="text-muted-foreground hover:text-foreground transition-colors truncate max-w-[100px] sm:max-w-[180px] whitespace-nowrap"
              >
                {label}
              </button>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
